export default __webpack_public_path__ + "static/media/org-insights-interests.91963338.png";